<template>
  <CCard class="moment loyalty moment_card">         
    <CCardBody class="p-0">
      <div ref="momentContainer" class="moment_container">
        <div class="moment_content" :class="{ 'flipped': isFlipped }">
          <div class="front" @click.stop="toggleFlip">
            <div class="flip_to_back">
              <span>{{$t('common.Tap_to_flip')}}</span>
              <div class="icon position-relative d-flex align-items-center justify-content-center ml-1">
                <i class="fas fa-rotate"/>                
              </div>
            </div>
                        
            <div ref="momentCard" 
                 class="moment_card" 
                 v-html="momentData.html"
                 v-show="isContentLoaded"
                 @load="handleContentLoad"/>

            <div v-if="showEditButton || showDeleteButton" class="moment_template_actions d-flex flex-row">
              <CButton v-if="showEditButton" 
                       @click.stop="openSidebarRight('edit_loyalty_smart_moment', { modules: modules, platform_permissions: platformPermissions, loyalty_smart_moment_id_external: momentData.loyalty_smart_moment_id_external });"
                       class="d-flex align-items-center" 
                       color="primary">
                <i class="fa-solid fa-pen"></i>
              </CButton>
              <CButton v-if="showDeleteButton" 
                       @click.stop="deleteSmartMoment(momentData)" 
                       class="d-flex align-items-center m-0" 
                       color="primary">
                <i class="fa-solid fa-trash"></i>
              </CButton>
            </div>
          </div>
          <div class="back d-flex flex-column" @click.stop="toggleFlip">
            <!-- <div class="flip_to_front">
              <span>{{$t('common.Tap_to_flip')}}</span>
              <div class="icon position-relative display-flex align-items-center justify-content-center ml-1">
                <i class="fas fa-rotate"/>
              </div>
            </div> -->
            <div class="w-100">
              <CRow class="w-100 m-0">
                <CCol cols="12" lg="12" md="12" sm="12">
                  <div class="d-flex">
                    <div class="stamp d-flex flex-grow-1 justify-content-end">
                      <img :src="apiBaseUrl + '/v1/common/cdn/file/image/base-dashboard/logo/harryhr_stamp.png/' + clientToken"/>
                    </div>
                  </div>
                </CCol>             
              </CRow>
            </div>

            <div class="w-100 d-flex flex-grow-1 moment_custom_message">
              <CRow class="h-100 w-100 m-0">
                <CCol cols="12" lg="12" md="12" sm="12">
                  <div class="h-100 w-100 text-center position-relative">
                    <div class="h-100 w-100 d-flex align-items-center justify-content-center custom_message_container">
                      <span v-if="momentData.custom_message" class="text-center">{{momentData.custom_message}}</span>                      
                    </div>
                  </div>
                </CCol>
              </CRow>              
            </div>

            <div class="w-100 moment_details">
              <CRow v-if="momentData.recipients && momentData.recipients.length > 0" class="w-100 m-0">
                <CCol cols="12" lg="12" md="12" sm="12" class="pb-0">
                  <div class="d-flex align-items-center">
                    <div class="h-100 d-flex align-items-center label_container">
                      <label class="m-0"><b>{{$t('To')}}:</b></label>
                    </div>
                    <div class="d-flex align-items-center moment_recipients">
                      <div v-for="(recipient, index) in momentData.recipients.slice(0, 5)" :key="index" class="recipient">
                        <div v-if="recipient.profile_image" 
                            class="profile_image" 
                            v-bind:style="{ backgroundImage: 'url(' + apiBaseUrl + '/v1/common/cdn/file/image/core-user-profile/' + recipient.user_id_external + '/' + recipient.profile_image + '/' + clientToken + ')' }">
                        </div>
                        <div v-else class="profile_icon">
                          <userProfileAvatar :username="recipient.name" :size="30"/>
                        </div>
                      </div>
                      <div v-if="momentData.recipients.length > 5" class="ml-1">
                        <span><b>{{momentData.recipients.length - 5}}+</b></span>
                      </div>
                      <div @click.stop="setMomentRecipientsPagination(); momentRecipientsModal = true;" class="ml-1 pointer">
                        <span>{{$t('common.Details')}}</span>
                      </div>
                    </div>                  
                  </div>
                </CCol>
              </CRow>              

              <CRow class="w-100 m-0">
                <CCol cols="12" lg="12" md="12" sm="12" class="pb-0">
                  <div class="d-flex align-items-center">
                    <div class="h-100 d-flex align-items-center label_container">
                      <label class="m-0"><b>{{$t('common.From')}}:</b></label>
                    </div>
                    <div v-if="momentData.sender" class="d-flex align-items-center moment_sender">
                      <div v-if="cdnBaseUrl"
                          class="profile_image mr-1"
                          v-bind:style="{ backgroundImage: 'url(' + apiBaseUrl + '/v1/common/cdn/file/image/loyalty-moment-sender/' + momentData.sender.loyalty_moment_sender_id_external + '/' + momentData.sender.profile_image_id + '/' + clientToken + ')' }">                      
                      </div>
                      <div v-else-if="momentData.sender.sender_alias" class="profile_icon mr-1">
                        <userProfileAvatar :username="momentData.sender.sender_alias" :size="25"/>
                      </div>
                      <span>{{momentData.sender.sender_alias}}</span>
                    </div>                                    
                    <div v-else class="d-flex align-items-center moment_sender">                  
                      <div v-if="momentData.sent_by_system_account == 'Y' && cdnBaseUrl" 
                          class="profile_image mr-1" 
                          v-bind:style="{ backgroundImage: 'url(' + getLogoSrc() + ')' }">
                      </div>
                      <div v-else-if="momentData.sent_by_system_account !== 'Y' && momentData.sent_by_profile_image" 
                          class="profile_image mr-1"
                          v-bind:style="{ backgroundImage: 'url(' + apiBaseUrl + '/v1/common/cdn/file/image/core-user-profile/' + momentData.sent_by_user_id_external + '/' + momentData.sent_by_profile_image + '/' + clientToken + ')' }">
                      </div>
                      <div v-else-if="momentData.sent_by_name" class="profile_icon mr-1">
                        <userProfileAvatar :username="momentData.sent_by_name" :size="25"/>
                      </div>                      
                      <span>{{momentData.sent_by_name}}</span>
                    </div>
                  </div>
                </CCol>
              </CRow>

              <CRow class="w-100 m-0 mt-2_5">
                <CCol cols="12" lg="12" md="12" sm="12">
                  <div class="d-flex align-items-center">
                    <div v-if="momentData.grant_points && momentData.points > 0" class="d-flex flex-grow-1 align-items-center currency">
                      <img :src="apiBaseUrl + '/v1/common/cdn/file/image/base-dashboard/credits/' + environmentTag + '_credit.png/' + clientToken" class="mr-1"/>
                      <span class="d-flex align-items-center">
                        <span class="count mr-1">{{momentData.points}}</span> {{momentData.points !== 1 ? $t('common.coins') : $t('common.coin')}}
                      </span>
                    </div>
                    <div class="h-100 d-flex align-items-center reach" :class="{'justify-content-end' : momentData.grant_points && momentData.points > 0}">
                      <span class="d-flex align-items-center">
                        <i class="icon top fas fa-sliders mr-1"/><span class="count mr-1">{{momentData.total_filters}}</span> {{momentData.total_filters !== 1 ? $t('common.filters') : $t('common.filter')}}
                      </span>
                    </div>
                  </div>
                </CCol>
              </CRow>
            </div>
          </div>
        </div>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import userProfileAvatar from "@/components/common/userProfileAvatar.vue";

export default {
  name: 'loyaltyMomentCard',
  props: ['modules', 'platformPermissions', 'momentData', 'showEditButton', 'showDeleteButton'],
  components: {
    userProfileAvatar
  },
  data() {
    return {
      cdnBaseUrl: null,
      apiBaseUrl: null,
      clientToken: null,
      companyIdExternal: null,
      companyImageId: null,    
      environmentTag: null,
      isFlipped: false,
      isContentLoaded: false,
      updateTimer: null,
      heightUpdateAttempts: 0,
      maxHeightUpdateAttempts: 5,
      minHeight: 550,
      contentObserver: null
    }
  },
  methods: {    
    getLogoSrc() {
      if(!this.companyImageId) {
        return `${this.apiBaseUrl}/v1/common/cdn/file/image/base-dashboard/logo/${this.environmentTag}_logo.png/${this.clientToken}`;
      } else {
        return `${this.apiBaseUrl}/v1/common/cdn/file/image/base-dashboard/${this.companyIdExternal}/${this.companyImageId}.png/${this.clientToken}`;
      }
    },
    deleteSmartMoment(momentData) {
      this.$bus.$emit('delete_loyalty_smart_moment', momentData);      
    },
    handleContentLoad() {
      this.isContentLoaded = true;
      this.updateCardHeight();
    },
    updateCardHeight() {
      if(this.updateTimer) clearTimeout(this.updateTimer);

      const updateHeight = () => {
        const momentCard = this.$refs.momentCard;
        const momentContainer = this.$refs.momentContainer;
        
        if (!momentCard || !momentContainer) {
          if (this.heightUpdateAttempts < this.maxHeightUpdateAttempts) {
            this.heightUpdateAttempts++;
            this.updateTimer = setTimeout(updateHeight, 100);
          }
          return;
        }

        // Get all images within the moment card
        const images = momentCard.getElementsByTagName('img');
        const imagePromises = Array.from(images).map(img => {
          return new Promise((resolve) => {
            if (img.complete) {
              resolve();
            } else {
              img.onload = () => resolve();
              img.onerror = () => resolve();
            }
          });
        });

        // Wait for all images to load before calculating height
        Promise.all(imagePromises).then(() => {
          const height = Math.max(momentCard.offsetHeight, this.minHeight);
          
          if (height > 0) {
            momentContainer.style.height = `${height}px`;
            this.isContentLoaded = true;
          } else if (this.heightUpdateAttempts < this.maxHeightUpdateAttempts) {
            this.heightUpdateAttempts++;
            this.updateTimer = setTimeout(updateHeight, 100);
          }
        });
      };

      this.$nextTick(updateHeight);
    },
    resetHeightUpdate() {
      this.heightUpdateAttempts = 0;
      this.isContentLoaded = false;
      this.updateCardHeight();
    },
    toggleFlip() {
      this.isFlipped = !this.isFlipped;
    },
    setupContentObserver() {
      if(this.contentObserver) this.contentObserver.disconnect();

      this.contentObserver = new MutationObserver((mutations) => {
        let shouldUpdate = false;
        mutations.forEach(mutation => {
          if(mutation.type === 'childList' || mutation.type === 'characterData' || mutation.type === 'attributes') shouldUpdate = true;
        });

        if(shouldUpdate) this.updateCardHeight();
      });

      if (this.$refs.momentCard) {
        this.contentObserver.observe(this.$refs.momentCard, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true
        });
      }
    }
  },
  watch: {
    'momentData.html': {
      handler() {
        this.resetHeightUpdate();
      },
      immediate: true
    },
    isContentLoaded(newVal) {
      if (newVal) {
        this.updateCardHeight();
      }
    }
  },
  mounted() {
    this.apiBaseUrl = process.env.VUE_APP_API_URL;
    this.cdnBaseUrl = process.env.VUE_APP_CDN_URL;
    this.clientToken = localStorage.getItem('token');

    if(localStorage.getItem('companyIdExternal')) this.companyIdExternal = localStorage.getItem('companyIdExternal');
    if(localStorage.getItem('companyImageId')) this.companyImageId = localStorage.getItem('companyImageId');
    if(localStorage.getItem('environmentTag')) this.environmentTag = localStorage.getItem('environmentTag');

    // Setup observers and initial height update
    this.$nextTick(() => {
      this.setupContentObserver();
      this.resetHeightUpdate();
    });
    
    // Add resize listener
    window.addEventListener('resize', this.updateCardHeight);
  },
  beforeDestroy() {
    // Cleanup
    window.removeEventListener('resize', this.updateCardHeight);
    
    if(this.updateTimer) clearTimeout(this.updateTimer);
    if(this.contentObserver) this.contentObserver.disconnect();
  }
}
</script>